export default __webpack_public_path__ + "img/logo.26bd867d.png";